import { render, staticRenderFns } from "./Articles.vue?vue&type=template&id=4596e9ba&scoped=true"
import script from "./Articles.vue?vue&type=script&lang=js"
export * from "./Articles.vue?vue&type=script&lang=js"
import style0 from "./Articles.vue?vue&type=style&index=0&id=4596e9ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4596e9ba",
  null
  
)

export default component.exports